export default {
  getFilters: state => state.filters,
  getReason: state => state.reason,
  uuid: state => state.uuid
}
